import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { File } from './components/file/file';
/*import { Election } from './components/election/election';*/

export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'file' },
  { path: 'file', component: File },
 /* { path: 'election', component: Election },*/
  { path: 'complete', component: Complete },
  { path: '**', redirectTo: 'file' },

];
